(function () {
  'use strict';
  if (window.__KOLDER_STOREFRONT_APP__) return;
  window.__KOLDER_STOREFRONT_APP__ = true;
  var display = window.matchMedia('(display-mode: standalone)');
  var panel = document.querySelector('[data-kolder-install]');
  if (!panel) return;
  var button = panel.querySelector('[data-kolder-install-button]');
  var message = panel.querySelector('[data-kolder-install-message]');
  var pending = null;
  var guide = panel.querySelector('[data-kolder-install-guide]');
  var iosSteps = panel.querySelector('[data-kolder-ios-steps]');
  var browserSteps = panel.querySelector('[data-kolder-browser-steps]');
  var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function updateLabel() { button.textContent = ios ? 'Cómo agregar KOLDER al iPhone' : pending ? 'Instalar app KOLDER' : 'Cómo instalar KOLDER'; }
  function showGuide() {
    if (guide) {
      guide.hidden = false;
      if (iosSteps) iosSteps.hidden = !ios;
      if (browserSteps) browserSteps.hidden = ios;
      button.setAttribute('aria-expanded', 'true');
      if (guide.scrollIntoView) guide.scrollIntoView({block:'nearest'});
    }
    message.textContent = ios
      ? 'La instalación se completa desde el menú de Safari, siguiendo estos pasos.'
      : 'La instalación se completa desde el menú del navegador, siguiendo estos pasos.';
  }
  function syncDisplay() {
    var installed = display.matches || navigator.standalone === true;
    document.documentElement.classList.toggle('kolder-app-mode', installed);
    panel.hidden = installed;
  }
  syncDisplay();
  updateLabel();
  if (display.addEventListener) display.addEventListener('change', syncDisplay);
  window.addEventListener('beforeinstallprompt', function (event) {
    event.preventDefault(); pending = event; updateLabel();
  });
  window.addEventListener('appinstalled', function () { pending = null; panel.hidden = true; });
  button.addEventListener('click', async function () {
    if (ios || !pending) { showGuide(); return; }
    var prompt = pending; pending = null; button.disabled = true;
    try { await prompt.prompt(); await prompt.userChoice; }
    catch (_) { message.textContent = 'Puedes instalar KOLDER desde el menú del navegador.'; }
    finally { button.disabled = false; updateLabel(); }
  });
  // Shopify retains checkout, account, order history and the session cart.
  // Do not intercept navigation, cache private pages or duplicate cart state.
})();
